// Components==============
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import DreamModal from 'components/UI/DreamModal/DreamModal';
import PersonModal from 'components/UI/PersonModal/PersonModal';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RichText from 'components/UI/RichText/RichText';
import Search from 'components/UI/Search/Search';
import SparkGroup from 'components/UI/SparkGroup/SparkGroup';
import Video from 'components/UI/TrainingContent/Video/Video';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useSparkGroups } from 'hooks/useSparkGroups';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { SkillModalContext } from '../SkillModal';
import './Overview.module.scss';
// =========================

export default function Overview() {
  const { setShowOverview, setSelected, inReflection, selected } = useContext(
    SkillModalContext
  );

  const [value, setValue] = useState('');

  const sparks = useRedux((state) =>
    state.spark?.entities.allIds.map((id) => state.spark?.entities.byId[id])
  )
    ?.filter((spark) => spark?.skill_id === selected?.id)
    .filter((spark) => spark?.name.toLowerCase().includes(value.toLowerCase()));

  const sparkGroups = useSparkGroups(sparks);

  const { setModal } = useRootModal();

  const dreams = useRedux((state) =>
    selected
      ? selected.dreams.map((d) => state.dream?.entities.byId[d.id])
      : undefined
  );

  const people = useRedux((state) =>
    selected
      ? selected.people.map((p) => state.people?.entities.byId[p.id])
      : undefined
  );

  function handleBack() {
    setShowOverview(false);
    if (!inReflection) setSelected(undefined);
  }

  const translate = useTranslate();

  return (
    <div styleName="wrapper">
      <div styleName="top">
        <Button color="grey-black" onClick={handleBack}>
          <FontAwesomeIcon icon={faChevronRight} />
          {translate(
            inReflection
              ? 'general.terms.previous'
              : 'reflection.terms.all-skills'
          )}
        </Button>
        <Search value={value} setValue={setValue} fluid />
      </div>
      <div styleName="content">
        <RichText content={selected?.description} />
        {!!selected?.video && <Video link={selected.video} />}
        {!!dreams?.length && (
          <div>
            <h3>{translate('reflection.terms.inspiration-dreams')}</h3>
            <div styleName="items">
              {!!dreams?.length &&
                dreams.map(
                  (dream) =>
                    !!dream && (
                      <ReflectionIcon
                        key={dream?.id}
                        image={dream?.image}
                        name={dream?.name}
                        onClick={() =>
                          setModal(
                            <DreamModal
                              origin="skill"
                              dream={dream}
                              originSkill={selected}
                            />
                          )
                        }
                      />
                    )
                )}
            </div>
          </div>
        )}
        {!!people?.length && (
          <div>
            <h3>{translate('reflection.terms.inspiration-people')}</h3>
            <div styleName="items">
              {!!people?.length &&
                people.map(
                  (p) =>
                    !!p && (
                      <ReflectionIcon
                        key={p?.id}
                        image={`/storage/${p?.image}`}
                        name={p?.name}
                        onClick={() =>
                          setModal(
                            <PersonModal person={p} originSkill={selected} />
                          )
                        }
                      />
                    )
                )}
            </div>
          </div>
        )}
        {!!sparkGroups.length && (
          <div>
            <h3>{translate('reflection.terms.all-sparks')}</h3>
            <div styleName="groups">
              <AnimatePresence>
                {sparkGroups?.map((group, index) => (
                  <SparkGroup key={index} group={group} value={value} />
                ))}
              </AnimatePresence>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
